import "./ContactPage.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faPhone, faEnvelope, faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import HeroTitle from "../../layouts/HeroTitle/HeroTitle";
import { useState } from 'react';
import { sendContactEmail } from '../../api/contactApi';
import { toast } from 'react-toastify';

function ContactPage() {
    const [formData, setFormData] = useState({
        email: '',
        subject: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await sendContactEmail(formData);
            toast.success('Votre message a été envoyé avec succès !');
            setFormData({
                email: '',
                subject: '',
                message: ''
            });
        } catch (error) {
            toast.error(error.message || 'Une erreur est survenue lors de l\'envoi du message');
        } finally {
            setIsLoading(false);
        }
    };

    return (
      <div className="contact-page">
        <HeroTitle title="CONTACT" />

        <div className="contact-container">
          <section className="contact-info-section">
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <h3>Téléphone</h3>
              <p>02 47 20 50 60</p>
            </div>
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <h3>Email</h3>
              <p>toursbouillon@gmail.com</p>
            </div>
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <h3>Adresse</h3>
              <p>6 rue des fusillés, Tours</p>
            </div>
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <h3>Horaires</h3>
              <div className="hours-grid">
                <span>Mardi - Samedi</span>
                <span>12h - 15h30</span>
                <span>Jeudi - Vendredi (Afterwork)</span>
                <span>À partir de 18h</span>
                <span>Dimanche - Lundi</span>
                <span>Fermé</span>
              </div>
            </div>
          </section>

          <section className="contact-form-section">
            <div className="form-container">
              <h2>Envoyez-nous un message</h2>
              <div className="section-decoration"></div>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Adresse email</label>
                  <input 
                    type="email" 
                    id="email" 
                    placeholder="votre@email.com" 
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Sujet du message</label>
                  <input 
                    type="text" 
                    id="subject" 
                    placeholder="Ex: Réservation, Question..." 
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Votre message</label>
                  <textarea 
                    id="message" 
                    placeholder="Écrivez votre message ici..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isLoading}
                >
                  <span>{isLoading ? 'Envoi en cours...' : 'Envoyer'}</span>
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </form>
            </div>
          </section>
        </div>

        <section className="map-section">
          <iframe 
            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=6%20rue%20des%20fusill%C3%A9s%2037000%20Tours+(ToursBouillon)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" 
            width="100%" 
            height="450" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy"
          ></iframe>
        </section>
      </div>
    );
}

export default ContactPage;